import { create } from "zustand";

const reviewStore = create((set) => ({
    reviewData: {
        interviewId: '',
        candidateId: ''
    },
    updateReviewData: (newData) =>
        set((state) => ({
            reviewData: { ...state.reviewData, ...newData },
        })),
}))

export default reviewStore